import { useEffect, useState } from "react";
import WorkSection from "../components/WorkSection";
import ChooseSection from "../components/ChooseSection";

export default function Home() {
  const slides = [
    "img2/2.png",
    "img2/3.png",
    "img2/4.png"
  ];

  const [index, setIndex] = useState(0);

  // Auto slider
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Contact form
  const [form, setForm] = useState({
    school_name: "",
    contact_person: "",
    phone: "",
    email: "",
    city_state: "",
    requirements: ""
  });

  const submitForm = async (e) => {
    e.preventDefault();

    const res = await fetch("http://localhost/api/save_enquiry.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    });

    const data = await res.json();
    alert(data.message);
  };
  
  

  return (
    <>
      {/* HEADER / SLIDER */}
      <div className="header">

        {slides.map((s, i) => (
          <div
            key={i}
            className={`slide ${i === index ? "active" : ""}`}
            style={{ backgroundImage: `url(${s})` }}
          />
        ))}

        {/* DOTS */}
        <div className="slider-dots">
          {slides.map((_, i) => (
            <div
              key={i}
              className={`dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>

        {/* HERO */}
        <div className="hero-content">
          <h1>
            Automatic <span>School ID Card</span>
          </h1>
          <p>
            Smart solution to generate student and staff ID cards automatically
            with photo, QR code and secure data management.
          </p>
        </div>
      </div>

      {/* ABOUT */}
      <section className="about-section">
        <div className="about-container">
          <h2>
            About <span>Quick ID Cards</span>
          </h2>

          <p className="about-text">
            Quick ID Cards helps schools automate ID card generation with
            photo capture, QR code, printing, and delivery.
          </p>

          <div className="about-grid">
            <div className="about-box">
              <h3>🎓 Complete ID Solution</h3>
              <p>End-to-end ID generation system.</p>
            </div>

            <div className="about-box">
              <h3>🔐 Secure & Reliable</h3>
              <p>Safe and accurate system.</p>
            </div>

            <div className="about-box">
              <h3>🚀 Future Ready</h3>
              <p>Scalable modern platform.</p>
            </div>
          </div>
        </div>
      </section>

      <WorkSection />
      
      <ChooseSection />

      {/* WHY CHOOSE */}
      <section className="choose-section">
        <div className="choose-container">
          <h2>
            Why Choose <span>Quick ID Cards?</span>
          </h2>

          <div className="choose-grid">
            {[
              "Save Time",
              "Photo App",
              "No Errors",
              "Quality",
              "Branding",
              "End-to-End"
            ].map((item, i) => (
              <div key={i} className="choose-box">
                <h3>{item}</h3>
                <p>Premium service advantage.</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="contact-us">
        <div className="container">
          <h2>Free Demo</h2>

          <form className="enquiry-form" onSubmit={submitForm}>
            <input placeholder="School Name"
              onChange={(e) => setForm({...form, school_name: e.target.value})} />

            <input placeholder="Contact Person"
              onChange={(e) => setForm({...form, contact_person: e.target.value})} />

            <input placeholder="Phone"
              onChange={(e) => setForm({...form, phone: e.target.value})} />

            <input placeholder="Email"
              onChange={(e) => setForm({...form, email: e.target.value})} />

            <input placeholder="City"
              onChange={(e) => setForm({...form, city_state: e.target.value})} />

            <textarea placeholder="Requirements"
              onChange={(e) => setForm({...form, requirements: e.target.value})} />

            <button type="submit">Submit</button>
          </form>
        </div>
      </section>

      
    </>
  );
}
